import { useInView } from "framer-motion";
import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
  direction?: "left" | "right" | "up" | "down";
  delay?: number;
  pixels?: number;
  length?: "short" | "medium" | "long";
};

export const AnimateTranslate = ({
  children,
  className,
  delay = 0,
  direction = "right",
  length = "medium",
  pixels = 70,
  ...props
}: Props) => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });

  let transform;

  switch (direction) {
    case "left":
      transform = `translateX(${pixels}px)`;
      break;
    case "right":
      transform = `translateX(-${pixels}px)`;
      break;
    case "up":
      transform = `translateY(${pixels}px)`;
      break;
    case "down":
      transform = `translateY(-${pixels}px)`;
      break;
    default:
      transform = `translateX(${pixels}px)`;
      break;
  }

  return (
    <div
      ref={ref}
      style={{
        transform: isInView ? "none" : transform,
        opacity: isInView ? 1 : 0,
        transition: `all ${
          length === "short" ? "0.2" : length === "medium" ? "0.5" : "1"
        }s ease-out ${delay.toString()}s`,
      }}
      {...props}
    >
      {children}
    </div>
  );
};
